import { useEffect, useState } from 'react';
import { fetchStandaloneTaskSupport } from '../../../../components/chartActions/credentialCapabilities';

// Extracted verbatim from ReferralActionBar's original credential-capability
// effect so the toolbar and the per-row quick-actions menu compute the standalone
// task gate identically. When there is no EMR integration credential the answer is
// immediately true; otherwise probe capabilities and default to false until the
// probe resolves. Intentionally uncached so tests that swap the probe
// implementation (and real credential changes) are always reflected.
const useStandaloneTaskSupport = (hasEmrIntegrationCredential) => {
  const [supported, setSupported] = useState(!hasEmrIntegrationCredential);

  useEffect(() => {
    let mounted = true;

    if (!hasEmrIntegrationCredential) {
      setSupported(true);
      return () => {
        mounted = false;
      };
    }

    setSupported(false);
    fetchStandaloneTaskSupport().then((value) => {
      if (mounted) setSupported(value);
    });

    return () => {
      mounted = false;
    };
  }, [hasEmrIntegrationCredential]);

  return supported;
};

export default useStandaloneTaskSupport;
